var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-table',{attrs:{"highlight-current-row":"","size":"small","height":"350px","data":_vm.dataTabel,"border":""}},_vm._l((_vm.tableHeader),function(value,key){return _c('el-table-column',{key:key,attrs:{"prop":key,"label":value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }